import { findLast, sortBy } from 'lodash';

import { demoCreationData } from '../data/demo_project/creation';
import { Creation, Deliverable, Request } from '../generated/graphql';
import { toJSDate } from './datetime';

const DEMO_IDS = demoCreationData.map((d) => d.data.creation.id);

// TODO: 存在するIDは使われてないよね？
export const isDemo = <C extends Pick<Creation, 'id'>>(creation: C) => DEMO_IDS.includes(creation.id);

export const getLatestDeliverable = <D extends Pick<Deliverable, 'createdAt'>>(creation: { deliverables: D[] }) => {
  if (creation.deliverables.length == 0) return;
  return sortBy(creation.deliverables, (a: D) => -toJSDate(a.createdAt).valueOf())[0];
};

export const getModificationRequestsWithoutDraft = <M extends Pick<Request, 'state'>>(creation: {
  modificationRequests: M[];
}) => {
  if (!creation.modificationRequests) {
    return [];
  }
  return creation.modificationRequests.filter((modificationRequest) => modificationRequest.state !== 'draft');
};

export const getLatestModificationRequest = <MR extends Pick<Request, 'targetDeliverableId'>>(creation: {
  deliverables: Pick<Deliverable, 'id' | 'createdAt'>[];
  modificationRequests: Array<MR>;
}) => {
  const latestDeliverable = getLatestDeliverable(creation);
  return (
    latestDeliverable &&
    findLast(
      creation.modificationRequests,
      (modificationRequest) => modificationRequest.targetDeliverableId === latestDeliverable.id,
    )
  );
};

export const PASSED_INSPECTION_CREATION_STATE = [
  'inspection_modification_requested',
  'submitted',
  'modification_requested',
  'approved',
  'canceled',
];
